import styled from "styled-components";
// 수상 카드: 상장 이미지 + 수여기관 + 내용 + 연도
const PrizeTemplate = ({ presenter, content, year, image }) => {
  return (
    <Div>
      <div className="frame">
        <PrizeImage src={image} alt="" />
      </div>
      <YearSpan>{year}</YearSpan>
      <PresenterSpan>{presenter}</PresenterSpan>
      <ContentSpan>{content}</ContentSpan>
    </Div>
  );
};
export default PrizeTemplate;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 1rem 1rem 1.25rem;
  border-radius: ${({ theme }) => theme.radius};
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.line};
  transition: box-shadow 0.2s, transform 0.2s;
  & > .frame {
    display: flex;
    justify-content: center;
    align-items: center;
    aspect-ratio: 3 / 4;
    margin-bottom: 0.75rem;
    border-radius: 0.6rem;
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    overflow: hidden;
  }
  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.md};
    transform: translateY(-3px);
  }
`;
const PrizeImage = styled.img`
  max-width: 82%;
  max-height: 88%;
  object-fit: contain;
  box-shadow: 0 6px 18px rgba(20, 36, 92, 0.18);
`;
const PresenterSpan = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
`;
const ContentSpan = styled.span`
  font-size: 0.95rem;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.monotone.dark};
`;
const YearSpan = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accent};
`;
